import {
  PAIN_MINUTES_DASHBOARD_PROXY_LOGIN,
  PAIN_MINUTES_DASHBOARD_PROXY_LOGIN_SUCCESS,
  PAIN_MINUTES_DASHBOARD_PROXY_LOGIN_ERROR,
  PAIN_MINUTES_DASHBOARD_PROXY_LOGIN_EMPTY,
} from '../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const PainMinutesDashboardProxyLogin = (state = initialState, action) => {
  switch (action.type) {
    case PAIN_MINUTES_DASHBOARD_PROXY_LOGIN:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case PAIN_MINUTES_DASHBOARD_PROXY_LOGIN_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case PAIN_MINUTES_DASHBOARD_PROXY_LOGIN_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case PAIN_MINUTES_DASHBOARD_PROXY_LOGIN_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default PainMinutesDashboardProxyLogin;
